import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import {
  bitgetWallet,
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  rabbyWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets'
import {
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  gnosis,
  mainnet,
  optimism,
  polygon,
  zkSync,
} from 'wagmi/chains'

const projectId =
  process.env.REACT_APP_WALLETCONNECT_PROJECT_ID ||
  process.env.REACT_APP_WALLET_CONNECT_ID ||
  '28284b025482b2086b67683e76511d31'

const pulsechain = {
  id: 369,
  name: 'PulseChain',
  network: 'pulsechain',
  nativeCurrency: {
    name: 'Pulse',
    symbol: 'PLS',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.pulsechain.com'],
    },
    public: {
      http: ['https://rpc.pulsechain.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'PulseScan',
      url: 'https://scan.pulsechain.com',
    },
  },
}

export const config = getDefaultConfig({
  appName: 'LibertySwap',
  projectId,
  chains: [mainnet, pulsechain, bsc, optimism, arbitrum, base, polygon, fantom, avalanche, gnosis, zkSync],
  ssr: false,
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, rabbyWallet, bitgetWallet, trustWallet, coinbaseWallet, injectedWallet, walletConnectWallet],
    },
  ],
})
